'use strict';
angular.module('amexReconciliationApp')
  .component('cycleMatchedReceiptsModal', {
    bindings: {
      closeModalCallback: '&'
    },
    templateUrl: 'scripts/views/components/cycle-matched-receipts-modal.html',
    controller: function (TransactionSearchModel,
                          BillingCycleModel,
                          ReceiptService,
                          $filter,
                          CardRepository,
                          $translate,
                          ReceiptRepository) {
      var self = this;
      var receiptsBeingFetched = false;

      self.isBcaManager = TransactionSearchModel.isBcaManager();
      self.currentPage = 1;
      self.pageSize = 12;
      self.totalReceipts = 0;
      self.matchedReceipts = [];
      self.closeModal = self.closeModalCallback;

      self.refreshReceipts = fetchReceipts;
      self.pageChanged = fetchReceipts;

      self.cardChanged = function (card) {
        self.currentCard = card;
        self.currentPage = 1;
        fetchReceipts();
      };

      self.isLoading = function () {
        return receiptsBeingFetched;
      };

      self.hasReceipts = function () {
        return !_.isEmpty(self.matchedReceipts);
      };

      self.moreThanOnePage = function() {
        return self.totalReceipts > self.pageSize;
      };

      self.billingCycleChanged = function (billingCycle) {
        self.currentPage = 1;
        this.currentBillingCycle = billingCycle;
      };

      function fetchReceipts() {
        var pagination = {
          currentPage: self.currentPage - 1,
          size: self.pageSize
        };

        var billingCycles = self.currentBillingCycle.endDate ? [self.currentBillingCycle.endDate] : _.map(_.filter(BillingCycleModel.billingCycles(), 'endDate'), 'endDate');
        var cardId = _.get(self.currentCard, 'cardId');

        receiptsBeingFetched = true;
        return ReceiptRepository.findMatchedByBillingCycles(pagination, billingCycles, cardId).then(function (response) {
          self.matchedReceipts = response.content;
          self.totalReceipts = response.totalElements;
        }).finally(function () {
          receiptsBeingFetched = false;
        });
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/cycleMatchedReceiptsModal.js
// module id = 443
// module chunks = 0